import { useQuery } from 'react-query';
import { CardRenderer } from '@/components/elements/Card';
import Container from '@/components/global/Container';
import Grid from '@/components/global/Grid';
import { TitleAndDescription } from '@/components/shared/TitleAndDescription';
import { IComponentBlocksStoryCardGrid, IComponentSharedTitleAndDescription, IStory } from '@/graphql/__generated__/global/types';
import { CardImageAspectRatio } from '@/helpers/determineAspectRatioByCardSpan';
import { I18nLocales } from '@/interfaces/locales.interfaces';
import { getAllStories } from '@/lib/strapiQueries';
import { useRouter } from 'next/router';

export const BlockStoryCardGrid = ({ titleDescription }: IComponentBlocksStoryCardGrid) => {
    const router = useRouter();
    const { data: stories } = useQuery(`stories-${router.locale}`, () => getAllStories(router.locale as I18nLocales), { staleTime: Infinity });

    if (!stories || !stories.length) {
        return null;
    }
    return (
        <Container>
            {titleDescription && <TitleAndDescription {...(titleDescription as IComponentSharedTitleAndDescription)} />}
            <Grid>
                {stories.map((story, index) => {
                    const { hero, slug } = story.attributes as IStory;
                    const { title, description, image, video } = hero ?? {};

                    const { playback_id } = video?.backgroundVideo?.data?.attributes ?? {};
                    let hoverImage;
                    let thumbnail;

                    if (playback_id) {
                        // Start time is set to 10s to avoid the first frame of the video
                        hoverImage = `https://image.mux.com/${playback_id}/animated.webp?start=10&width=480&fps=24`;
                    }

                    if (!image && playback_id) {
                        thumbnail = `https://image.mux.com/${playback_id}/thumbnail.webp?width=480&fps=24`;
                    }

                    return (
                        <CardRenderer
                            key={index}
                            card={{
                                title,
                                image: image?.image || thumbnail,
                                hoverImage: hoverImage,
                                description,
                                eyebrowText: 'Story Guide',
                                aspectRatio: CardImageAspectRatio['one-third'],
                                link: {
                                    id: slug,
                                    label: 'Read Story',
                                    linkToExternalPage: slug,
                                },
                            }}
                            span="oneThird"
                        />
                    );
                })}
            </Grid>
        </Container>
    );
};

export default BlockStoryCardGrid;
